import NotificationContainer from '@common/components/NotificationContainer';
import userPersonas from '@common/constants/userPersonas';
import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

interface Props {
  createManualPaymentOnClick: () => any;
  closeManualPaymentModal: () => any;
}

const ManualPaymentModal = ({ closeManualPaymentModal, createManualPaymentOnClick }: Props) => {
  return (
    <Modal
      open={true}
      trigger={null}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeManualPaymentModal();
        }
      }}
      header={
        <Box css={{ padding: '16px 48px 16px 16px !important' }}>
          <Heading level={2} textStyle="heading-xs">
            Mark this month as paid?
          </Heading>
        </Box>
      }
      body={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <NotificationContainer modal persona={userPersonas.RENTER} />
          <Paragraph>When you mark a month as paid, it cannot be undone.</Paragraph>
        </Box>
      }
      footer={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <ButtonGroup aria-label="action-buttons" role="group">
            <TextButton onClick={closeManualPaymentModal}>Back</TextButton>
            <Button emphasis="filled" onClick={createManualPaymentOnClick}>
              Mark as paid
            </Button>
          </ButtonGroup>
        </Box>
      }
    />
  );
};

export default ManualPaymentModal;
